import React from "react"
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap'
import styled from 'styled-components'
import { MdViewDay, MdViewHeadline } from 'react-icons/md'
import {
  projectInformationAction,
  timesheetAction,
  efficiencyAction,
  ppsAction,
  employeeAction,
  saleProductAction,
  headerAction,
} from '../../actions'
import { authSelector, headerSelector } from './../../selectors'
import noImage from '../../static/images/Not_available.jpg'
import noti from '../../static/images/notifications-button.svg'
import menu from '../../static/images/menu-1.svg'
import listmenu from '../../static/images/menu-2.svg'
import "../../static/css/index.css"
import { COLORS, FONTS } from '../../constants'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: true,
    }
  }

  toggleNavbar = () => {
    this.setState({ collapsed: !this.state.collapsed })
  }

  canShowManual = (path) => {
    let page = ''
    let canShow = false
    if (path.includes('project_information')) {
      page = 'project_information'
      canShow = true
    } else if (path.includes('time_sheet')) {
      page = 'time_sheet'
      canShow = true
    } else if (path.includes('efficiency_resource')) {
      page = 'efficiency_resource'
      canShow = true
    } else if (path.includes('project_profit_sheet')) {
      page = 'project_profit_sheet'
      canShow = true
    } else if (path.includes('sale_product')) {
      page = 'sale_product'
      canShow = true
    } else if (path.includes('user')) {
      page = 'user'
      canShow = true
    }
    return { canShow, page }
  }

  canShowToggle = () => {
    const { path } = this.props
    const _path = path.split('/')
    return _path.length > 2 && _path[1] === 'project_information'
  }

  hideHeader = value => {
    this.props.hideHeader(value)
  }

  render() {
    const { isHide } = this.props
    const authData = get(this.props, 'authData')
    const showManual = this.canShowManual(get(this.props, 'path'))
    const inboxNotification = get(authData, 'inboxNotification')
    const imageThumbnail = get(authData, 'user.image_thumbnail_url')
    const username = `${get(authData, 'user.first_name', '')} ${get(authData, 'user.last_name', '')}`
    const showToggle = this.canShowToggle()

    return (
      <HeadDivStyle>
        <ButtonMenuMobile onClick={ this.props.onSetSidebarOpen }>
          <Menu src={ listmenu } />
        </ButtonMenuMobile>
        <ButtonMenuDesktop onClick={ this.props.onSetFullSidebarOpen }>
          <Menu src={ menu } />
        </ButtonMenuDesktop>
        <CustomNav className="mr-auto" navbar>
          <NavItem>
            <NavLinkHead>{ get(this.props, 'header') }</NavLinkHead>
          </NavItem>
        </CustomNav>
        { showToggle &&
        <ToggleWrapper>
          <Toggle active={ isHide } onClick={ () => this.hideHeader(true) }>
            <MdViewHeadline style={ { fontSize: 20 } } />
          </Toggle>
          <Toggle active={ !isHide } onClick={ () => this.hideHeader(false) }>
            <MdViewDay style={ { fontSize: 20 } } />
          </Toggle>
        </ToggleWrapper>
        }
        <Navbar
          color="#ffffff"
          light
          expand="md"
          style={ { height: '100%' } }
        >
          { showManual.canShow &&
            <ManualButton onClick={ () => {
              if (showManual.page === 'project_information') {
                this.props.openManualProjectInformation()
              } else if (showManual.page === 'time_sheet') {
                this.props.openManualTimesheet()
              } else if (showManual.page === 'project_profit_sheet') {
                this.props.openManualProjectProfitSheet()
              } else if (showManual.page === 'sale_product') {
                this.props.openManualSlaeProduct()
              } else if (showManual.page === 'user') {
                this.props.openManualEmployee()
              } else this.props.openManualEfficiency()
            } }
            >
              Manual
            </ManualButton>
          }
          <NavRight navbar>
            <NotiNavItem>
              <NavLink href="/inbox">
                <div>
                  <NotiImage src={ noti } alt="notification" />
                  { inboxNotification > 0 &&
                    <NotiWrapper>
                      <Notification>
                        { inboxNotification }
                      </Notification>
                    </NotiWrapper>
                  }
                </div>
              </NavLink>
            </NotiNavItem>
            <NotiNavItem>
              <NavLink href="#">
                <UserImgProfile
                  src={ imageThumbnail !== '' && imageThumbnail !== undefined ? imageThumbnail : noImage }
                  alt="User"
                />
              </NavLink>
            </NotiNavItem>
            <NameNavItem>
              <NameNavLink>
                <UncontrolledDropdown nav inNavbar tag="div">
                  <DropdownToggle nav caret>
                    <TextName>
                      { username }
                    </TextName >
                  </DropdownToggle>
                  <DropdownMenuNav right >
                    <DropdownItem onClick={ () => window.location = '/change_password' }>
                      Change Password
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={ this.props.logout }>
                      Log out
                    </DropdownItem>
                  </DropdownMenuNav>
                </UncontrolledDropdown>
              </NameNavLink>
            </NameNavItem>
          </NavRight>
        </Navbar>
      </HeadDivStyle>
    )
  }
}

Header.propTypes = {
  openManualTimesheet: PropTypes.func,
  openManualEfficiency: PropTypes.func,
  openManualProjectInformation: PropTypes.func,
  openManualProjectProfitSheet: PropTypes.func,
  onSetSidebarOpen: PropTypes.func,
  onSetFullSidebarOpen: PropTypes.func,
  logout: PropTypes.func,
}
Header.defaultProps = {
  openManualTimesheet: () => {},
  openManualEfficiency: () => {},
  openManualProjectInformation: () => {},
  openManualProjectProfitSheet: () => {},
  onSetSidebarOpen: () => {},
  onSetFullSidebarOpen: () => {},
  logout: () => {},
}

const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getAuth,
  isHide: headerSelector.getIsHide,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  openManualTimesheet: timesheetAction.openManual,
  openManualEfficiency: efficiencyAction.openManual,
  openManualProjectInformation: projectInformationAction.openManual,
  openManualProjectProfitSheet: ppsAction.openManual,
  openManualEmployee: employeeAction.openManual,
  openManualSlaeProduct: saleProductAction.openManual,
  hideHeader: headerAction.hideHeader,

}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Header)

const NotiWrapper = styled.div`
  position: relative;
  left: 40%;
  flex: 0 0 auto;
`
const Notification = styled.p`
  background-color: red;
  color: white;
  position: absolute;
  left: 10%;
  font-size: 12px;
  border-radius: 15px;
  padding-left: 5px;
  padding-right: 5px;
`
const NotiImage = styled.img`
  width : 28px ;
  height : 28px ;
  float: right;
  margin-top: 10px;
`
const ManualButton = styled(Button)`
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM};
  color: ${COLORS.BLACK};
  border: 1px solid #cccccc;
  background-color: #ffffff;

  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const Menu = styled.img`
  width : 80%;
  height : 80%;
`
const NotiNavItem = styled(NavItem)`
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const DropdownMenuNav = styled(DropdownMenu)`
  position:relative;
  z-index: 5;
  top:0;
`
const TextName = styled.span`
  color: #000;
  @media (max-width: 575.98px) {
    color: #ffffff;
    font-size: 14px ;
  }
  @media (max-width: 767.98px) {
    color: #ffffff;
    font-size: 14px ;
  }
`
const ButtonMenuMobile = styled(Button)`
  width : 22px ;
  height : 30px ;
  padding: 0px !important;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #D44B49;
  border : 1px solid #D44B49;
  @media (min-width: 576px) {
    width : 25px;
    height : 25px;
    background-color: #D44B49;
  }
  @media (min-width: 768px) and (-webkit-min-device-pixel-ratio: 2) {
    display:none;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    display:none;
  }
  @media (max-width: 991.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape){
    width : 30px;
    height : 30px;
    background-color: #D44B49;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
  display:none;
  }
`
const NavRight = styled(Nav)`
  z-index: 5 ;
  float: right;
  padding-right: 2% ;
  @media (max-width: 575.98px) {
    float: left;
  }
  @media (max-width: 767.98px) {
    float: left;
  }
`
const ButtonMenuDesktop = styled(Button)`
  width : 30px;
  height: 40px;
  padding: 0px !important;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 20px;
  margin-right: 10px;
  background-color: #FFFFFF;
  border : 1px solid #FFFFFF;
  @media (max-width: 576px) {
    display:none;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) {
    display:none;
  }
`
const UserImgProfile = styled.img`
  width : 50px;
  height : 50px;
  border-radius: 50%;
  border: 1px solid #ccc;
`
const HeadDivStyle = styled.div`
  background-color: #ffffff;
  height: 70px;
  position: relative;
  display: flex;
  border-bottom: 2px solid #F1F1F1 ;
  -webkit-box-shadow:0px 1px 1px #F1F1F1;
  -moz-box-shadow:0px 1px 1px #F1F1F1;
  box-shadow:0px 1px 1px #F1F1F1;
  @media (max-width: 575.98px) {
    background-color: #D44B49;
    border-bottom: 2px solid #D44B49 ;
    top: 0;
    height: 40px ;
    .navbar {
      padding: 0rem ;
    }
  }
  @media (max-width: 767.98px) {
    background-color: #D44B49;
    border-bottom: 2px solid #D44B49 ;
    top: 0;
    height: 40px ;
    .navbar {
      padding: 0rem 0.5rem;
    }
  }
`
const NavLinkHead = styled.div`
  font-size: ${FONTS.HEADER_SIZE};
  font-family: ${FONTS.GOTHAM_MEDIUM};
  color: ${COLORS.BLACK};
  @media (max-width: 575.98px) {
    display:none;
  }
  @media (max-width: 767.98px) {
    display:none;
  }
`
const NameNavLink = styled.div`
  font-size: 16px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  color: ${COLORS.BLACK};
  margin-right: 5%;
  padding-top: 10px;
  padding-bottom: 10px;
  width: max-content;
  @media (max-width: 575.98px) {
    font-size: 14px ;
    padding-top: 0px;
  }
  @media (max-width: 767.98px) {
    font-size: 14px ;
    padding-top: 0px;
  }
`
const NameNavItem = styled(NavItem)`
  margin-top: auto;
  margin-bottom: auto;
`
const CustomNav = styled(Nav)`
  margin-top: auto;
  margin-bottom: auto;
`

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Toggle = styled.div`
  width: 48px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.active ? '#D44B49' : '#FFFFFF')};
  border: ${p => (p.active ? '1px solid #AD2624;' : '1px solid #F1F1F1;')};
  color: ${p => (p.active ? '#FFFFFF' : '#D44B49')};
  border-radius: 20px 0px 0px 20px;
  cursor: pointer;

  :nth-last-child(1) {
    border-radius: 0 20px 20px 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/header/index.js